import * as Reactivity from 'effect/unstable/reactivity/Reactivity';
import { Effect } from 'effect';

import { reactivityKeys } from '../reactivityKeys';
import { RuntimeClientAtom } from '../../runtime/RuntimeClient';

export const invalidateFavouriteListsAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* () {
    yield* Reactivity.invalidate([reactivityKeys.favouriteLists]);
  })
);

export const invalidateFavouriteListProductsAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* () {
    yield* Reactivity.invalidate([reactivityKeys.favouriteListProducts]);
  })
);
